export default "__VITE_ASSET__7a2c39a7__"